import React from "react"
import {
    Box,
    Radio,
    RadioGroup,
    FormControlLabel,
    Typography,
    styled,
} from "@mui/material"
import ValidationErrorText from "../common/ValidationErrorText"

// Custom-styled Radio button
const CustomRadio = styled(Radio)(({ theme }) => ({
    padding: 4,
    '&.Mui-checked': {
        color: '#1976d2',
    },
}))

const labelStyle = {
    fontSize: '13px',
    padding: '2px 8px',
    fontWeight: '500',
    borderRadius: '4px',
    border: 'none',
    marginRight: '8px',
    '&:hover': {
        backgroundColor: 'transparent',
    },
}

const ExamModeSelector = ({ label, value = "", onChange, readOnly = false,fieldError }) => {
    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '13px', mb: 1 }}>
                {label}
            </Typography>
            <RadioGroup
                row
                value={value}
                onChange={readOnly ? undefined : (e) => onChange(e.target.value)}
            >
                {["Online", "Offline", "Hybrid"].map((option) => (
                    <FormControlLabel
                        key={option}
                        value={option}
                        control={<CustomRadio size="small" disabled={readOnly} />}
                        label={option}
                        sx={{
                            ...labelStyle,
                            backgroundColor: value === option ? "transparent" : "transparent",
                            borderColor: value === option ? "#1976d2" : "#ccc",
                            '& .MuiTypography-root': {
                                fontSize: '13px',
                                fontWeight: '500',
                                color: '#15243E',
                            }
                        }}
                        disabled={readOnly}
                    />
                ))}
            </RadioGroup>
        <ValidationErrorText error={fieldError}/>  
        </Box>
    )
}

export default ExamModeSelector
